// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle6NewForm from "../../randing/RandingStyle6NewForm";
import RandingStyle6 from "../../randing/RandingStyle6";

function Randing118({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle6
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/118/1.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/118/2.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/078/25012204.jpg`} //질문이미지
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/078/25012203.gif`}
      formFieldColor="white"
      qOptions={["1~4개", "5개 이상", "전체", "상담필요"]}
      qOptionColor="blue"
      questionType="btn"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기' 버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/navy/costBenefitButton.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
    />
  );
}

export default Randing118;
